'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var generateAction = require('@piconetworks/generate-action');
var produce = require('immer');
var effects = require('redux-saga/effects');
var endpoints = require('@piconetworks/endpoints');
var networkMiddleware = require('@piconetworks/network-middleware');
var Duck = require('extensible-duck');
var reselect = require('reselect');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var generateAction__default = /*#__PURE__*/_interopDefaultLegacy(generateAction);
var produce__default = /*#__PURE__*/_interopDefaultLegacy(produce);
var Duck__default = /*#__PURE__*/_interopDefaultLegacy(Duck);

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var getHistory = generateAction__default['default']({
  baseActionCreatorName: 'getPurchaseHistory',
  baseActionTypeName: 'GET_PURCHASE_HISTORY'
});
var getSwitchProducts$1 = generateAction__default['default']({
  baseActionCreatorName: 'getSwitchProducts',
  baseActionTypeName: 'GET_SWITCH_PRODUCTS'
});
var createSwitchProduct$1 = generateAction__default['default']({
  baseActionCreatorName: 'createSwitchProduct',
  baseActionTypeName: 'CREATE_SWITCH_PRODUCT'
});
var getSwitchProration$1 = generateAction__default['default']({
  baseActionCreatorName: 'getSwitchProration',
  baseActionTypeName: 'GET_SWITCH_PRORATION'
});
var getGift$1 = generateAction__default['default']({
  baseActionCreatorName: 'getGift',
  baseActionTypeName: 'GET_GIFT'
});
var createGift$1 = generateAction__default['default']({
  baseActionCreatorName: 'createGift',
  baseActionTypeName: 'CREATE_GIFT'
});
var updateGift$1 = generateAction__default['default']({
  baseActionCreatorName: 'updateGift',
  baseActionTypeName: 'UPDATE_GIFT'
});
var deleteGift$1 = generateAction__default['default']({
  baseActionCreatorName: 'deleteGift',
  baseActionTypeName: 'DELETE_GIFT'
});
var purchaseProduct$1 = generateAction__default['default']({
  baseActionCreatorName: 'purchaseProduct',
  baseActionTypeName: 'PURCHASE_PRODUCT'
});
var reactivateProduct$1 = generateAction__default['default']({
  baseActionCreatorName: 'reactivateProduct',
  baseActionTypeName: 'REACTIVATE_PRODUCT'
});
var cancelProduct$1 = generateAction__default['default']({
  baseActionCreatorName: 'cancelProduct',
  baseActionTypeName: 'CANCEL_PRODUCT'
});
var types = [].concat(_toConsumableArray(getHistory.types), _toConsumableArray(getSwitchProducts$1.types), _toConsumableArray(createSwitchProduct$1.types), _toConsumableArray(getSwitchProration$1.types), _toConsumableArray(getGift$1.types), _toConsumableArray(createGift$1.types), _toConsumableArray(updateGift$1.types), _toConsumableArray(deleteGift$1.types), _toConsumableArray(purchaseProduct$1.types), _toConsumableArray(reactivateProduct$1.types), _toConsumableArray(cancelProduct$1.types));

var creators = function creators(duck) {
  return Object.assign({}, getHistory.creators(duck), getSwitchProducts$1.creators(duck), createSwitchProduct$1.creators(duck), getSwitchProration$1.creators(duck), getGift$1.creators(duck), createGift$1.creators(duck), updateGift$1.creators(duck), deleteGift$1.creators(duck), purchaseProduct$1.creators(duck), reactivateProduct$1.creators(duck), cancelProduct$1.creators(duck));
};

var initialState = {
  purchases: {
    data: null,
    error: null
  },
  product: {
    data: null,
    error: null
  },
  switchProducts: {
    data: [],
    loading: false,
    error: null,
    switchProductId: null
  },
  switchProration: {
    data: null,
    error: null
  },
  gift: {
    data: null,
    error: null
  }
};

var reducer = function reducer(state, _ref, duck) {
  var type = _ref.type,
      payload = _ref.payload,
      error = _ref.error;
  return produce__default['default'](state, function (draftState) {
    switch (type) {
      case duck.types.GET_PURCHASE_HISTORY:
        draftState.purchases = initialState.purchases;
        break;

      case duck.types.GET_PURCHASE_HISTORY_SUCCESS:
        draftState.purchases.data = payload;
        break;

      case duck.types.GET_PURCHASE_HISTORY_ERROR:
        draftState.purchases.error = error;
        break;

      case duck.types.GET_SWITCH_PRODUCTS:
        draftState.switchProducts.error = null;
        draftState.switchProducts.loading = true;
        break;

      case duck.types.GET_SWITCH_PRODUCTS_SUCCESS:
        draftState.switchProducts.data = payload === null || payload === void 0 ? void 0 : payload.data;
        draftState.switchProducts.loading = false;
        draftState.switchProducts.switchProductId = payload === null || payload === void 0 ? void 0 : payload.productId;
        break;

      case duck.types.CREATE_SWITCH_PRODUCT_ERROR:
      case duck.types.GET_SWITCH_PRODUCTS_ERROR:
        draftState.switchProducts.error = error;
        draftState.switchProducts.switchProductId = null;
        draftState.switchProducts.loading = false;
        break;

      case duck.types.CREATE_SWITCH_PRODUCT:
        draftState.switchProducts.error = initialState.switchProducts.error;
        break;

      case duck.types.CREATE_SWITCH_PRODUCT_SUCCESS:
        draftState.switchProducts.data = [].concat(_toConsumableArray(draftState.switchProducts.data), [payload]);
        break;

      case duck.types.GET_SWITCH_PRORATION:
        draftState.switch_proration = initialState.switch_proration;
        break;

      case duck.types.GET_SWITCH_PRORATION_SUCCESS:
        draftState.switch_proration.data = payload;
        break;

      case duck.types.GET_SWITCH_PRORATION_ERROR:
        draftState.switch_proration.error = error;
        break;

      case duck.types.GET_GIFT:
      case duck.types.UPDATE_GIFT:
      case duck.types.CREATE_GIFT:
      case duck.types.DELETE_GIFT_SUCCESS:
        draftState.gift = initialState.gift;
        break;

      case duck.types.GET_GIFT_SUCCESS:
      case duck.types.UPDATE_GIFT_SUCCESS:
      case duck.types.CREATE_GIFT_SUCCESS:
        draftState.gift.data = payload;
        break;

      case duck.types.DELETE_GIFT_ERROR:
      case duck.types.UPDATE_GIFT_ERROR:
      case duck.types.CREATE_GIFT_ERROR:
      case duck.types.GET_GIFT_ERROR:
        draftState.gift.error = error;
        break;

      case duck.types.CANCEL_PRODUCT:
      case duck.types.REACTIVATE_PRODUCT:
      case duck.types.PURCHASE_PRODUCT:
        draftState.product = initialState.product;
        break;

      case duck.types.PURCHASE_PRODUCT_SUCCESS:
      case duck.types.REACTIVATE_PRODUCT_SUCCESS:
      case duck.types.CANCEL_PRODUCT_SUCCESS:
        draftState.product.data = payload;
        break;

      case duck.types.REACTIVATE_PRODUCT_ERROR:
      case duck.types.CANCEL_PRODUCT_ERROR:
      case duck.types.PURCHASE_PRODUCT_ERROR:
        draftState.product.error = error;
        break;

    }
  });
};

function* getGift(_ref) {
  var types = _ref.types;

  try {
    var _yield$call = yield effects.call(networkMiddleware.picoAPIHelper, {
      url: endpoints.PURCHASE_GIFT(),
      method: 'get'
    }),
        data = _yield$call.data;

    if (data) {
      yield effects.put({
        type: types.GET_GIFT_SUCCESS,
        payload: data
      });
    } else {
      throw new Error('unable to fetch gifts');
    }
  } catch (error) {
    yield effects.put({
      type: types.GET_GIFT_ERROR,
      error: (error === null || error === void 0 ? void 0 : error.message) || 'GET_GIFT_ERROR'
    });
  }
}

function* createGift(_ref) {
  var types = _ref.types,
      payload = _ref.payload;

  try {
    var _yield$call = yield effects.call(networkMiddleware.picoAPIHelper, {
      url: endpoints.PURCHASE_GIFT(),
      method: 'post',
      data: payload
    }),
        data = _yield$call.data;

    if (data) {
      yield effects.put({
        type: types.CREATE_GIFT_SUCCESS,
        payload: data
      });
    } else {
      throw new Error('unable to create gift');
    }
  } catch (error) {
    yield effects.put({
      type: types.CREATE_GIFT_ERROR,
      error: (error === null || error === void 0 ? void 0 : error.message) || 'CREATE_GIFT_ERROR'
    });
  }
}

function* deleteGift(_ref) {
  var types = _ref.types,
      giftId = _ref.payload;

  try {
    var _yield$call = yield effects.call(networkMiddleware.picoAPIHelper, {
      url: "".concat(endpoints.ME_PAYMENT(), "/").concat(giftId),
      method: 'delete'
    }),
        status = _yield$call.status;

    if (status === 200) {
      yield effects.put({
        type: types.DELETE_GIFT_SUCCESS,
        payload: giftId
      });
    } else {
      throw new Error("unable to delete gift, ".concat(giftId));
    }
  } catch (error) {
    yield effects.put({
      type: types.DELETE_GIFT_ERROR,
      error: (error === null || error === void 0 ? void 0 : error.message) || 'DELETE_GIFT_ERROR'
    });
  }
}

function* updateGift(_ref) {
  var types = _ref.types,
      payload = _ref.payload;

  try {
    var _yield$call = yield effects.call(networkMiddleware.picoAPIHelper, {
      url: "".concat(endpoints.PURCHASE_GIFT(), "/").concat(payload.id),
      method: 'put',
      data: payload
    }),
        data = _yield$call.data;

    if (data) {
      yield effects.put({
        type: types.UPDATE_GIFT_SUCCESS,
        payload: data
      });
    } else {
      throw new Error('unable to update gift');
    }
  } catch (error) {
    yield effects.put({
      type: types.UPDATE_GIFT_ERROR,
      error: (error === null || error === void 0 ? void 0 : error.message) || 'UPDATE_GIFT_ERROR'
    });
  }
}

var getGiftSagas = function getGiftSagas(duck) {
  return {
    getGift: function* getGift$1(payload) {
      yield getGift(Object.assign({}, payload, duck));
    },
    createGift: function* createGift$1(payload) {
      yield createGift(Object.assign({}, payload, duck));
    },
    deleteGift: function* deleteGift$1(payload) {
      yield deleteGift(Object.assign({}, payload, duck));
    },
    updateGift: function* updateGift$1(payload) {
      yield updateGift(Object.assign({}, payload, duck));
    }
  };
};

function* purchaseProduct(_ref) {
  var types = _ref.types,
      payload = _ref.payload;

  try {
    var _yield$call = yield effects.call(networkMiddleware.picoAPIHelper, {
      url: "".concat(endpoints.PURCHASE_PRODUCT(), "/").concat(payload.id),
      method: 'post',
      data: payload
    }),
        data = _yield$call.data;

    if (data) {
      yield effects.put({
        type: types.PURCHASE_PRODUCT_SUCCESS,
        payload: data
      });
    } else {
      throw new Error("unable to purchase product");
    }
  } catch (error) {
    yield effects.put({
      type: types.PURCHASE_PRODUCT_ERROR,
      error: (error === null || error === void 0 ? void 0 : error.message) || 'PURCHASE_PRODUCT_ERROR'
    });
  }
}

function* cancelProduct(_ref) {
  var types = _ref.types,
      productOptionId = _ref.payload;

  try {
    var _yield$call = yield effects.call(networkMiddleware.picoAPIHelper, {
      url: "".concat(endpoints.PURCHASE_PRODUCT(), "/").concat(productOptionId),
      method: 'delete'
    }),
        status = _yield$call.status;

    if (status === 200) {
      yield effects.put({
        type: types.CANCEL_PRODUCT_SUCCESS,
        payload: giftId
      });
    } else {
      throw new Error("unable to cancel product, ".concat(productOptionId));
    }
  } catch (error) {
    yield effects.put({
      type: types.CANCEL_PRODUCT_ERROR,
      error: (error === null || error === void 0 ? void 0 : error.message) || 'CANCEL_PRODUCT_ERROR'
    });
  }
}

function* reactivateProduct(_ref) {
  var types = _ref.types,
      productOptionId = _ref.payloadP;

  try {
    var _yield$call = yield effects.call(networkMiddleware.picoAPIHelper, {
      url: "".concat(endpoints.PURCHASE_PRODUCT(), "/").concat(productOptionId),
      method: 'put'
    }),
        data = _yield$call.data;

    if (data) {
      yield effects.put({
        type: types.REACTIVATE_PRODUCT_SUCCESS,
        payload: data
      });
    } else {
      throw new Error("unable to reactivate product, ".concat(productOptionId));
    }
  } catch (error) {
    yield effects.put({
      type: types.REACTIVATE_PRODUCT_ERROR,
      error: (error === null || error === void 0 ? void 0 : error.message) || 'REACTIVATE_PRODUCT_ERROR'
    });
  }
}

var getProductSagas = function getProductSagas(duck) {
  return {
    purchaseProduct: function* purchaseProduct$1(payload) {
      yield purchaseProduct(Object.assign({}, payload, duck));
    },
    cancelProduct: function* cancelProduct$1(payload) {
      yield cancelProduct(Object.assign({}, payload, duck));
    },
    reactivateProduct: function* reactivateProduct$1(payload) {
      yield reactivateProduct(Object.assign({}, payload, duck));
    }
  };
};

function* createSwitchProduct(_ref) {
  var types = _ref.types,
      payload = _ref.payload;

  try {
    var _yield$call = yield effects.call(networkMiddleware.picoAPIHelper, {
      url: "".concat(endpoints.PURCHASE_SWITCH(), "/").concat(payload.id),
      method: 'post',
      data: payload
    }),
        data = _yield$call.data;

    if (data) {
      yield effects.put({
        type: types.CREATE_SWITCH_PRODUCT_SUCCESS,
        payload: data
      });
    } else {
      throw new Error('unable to create switch product');
    }
  } catch (error) {
    yield effects.put({
      type: types.CREATE_SWITCH_PRODUCT_ERROR,
      error: (error === null || error === void 0 ? void 0 : error.message) || 'CREATE_SWITCH_PRODUCT_ERROR'
    });
  }
}

function* getSwitchProducts(_ref) {
  var types = _ref.types,
      productId = _ref.productId,
      publisherId = _ref.publisherId;

  try {
    var _state$purchase;

    if (!productId) {
      throw new Error('Invalid product id');
    }

    var state = yield effects.select();
    var switchProducts = state === null || state === void 0 ? void 0 : (_state$purchase = state.purchase) === null || _state$purchase === void 0 ? void 0 : _state$purchase.switchProducts;
    var currentProductId = switchProducts.switchProductId;

    if (currentProductId !== productId) {
      var _yield$call = yield effects.call(networkMiddleware.picoAPIHelper, {
        url: "".concat(endpoints.PURCHASE_SWITCH(), "/?current_product_id=").concat(productId),
        method: 'get',
        headers: {
          publisherid: publisherId
        }
      }),
          data = _yield$call.data;

      if (data !== null && data !== void 0 && data.switchable_products) {
        yield effects.put({
          type: types.GET_SWITCH_PRODUCTS_SUCCESS,
          payload: {
            data: data.switchable_products,
            productId: productId
          }
        });
      } else {
        throw new Error('unable to fetch switch products');
      }
    } else {
      var currProducts = switchProducts === null || switchProducts === void 0 ? void 0 : switchProducts.data;
      yield effects.put({
        type: types.GET_SWITCH_PRODUCTS_SUCCESS,
        payload: {
          data: currProducts,
          productId: productId
        }
      });
    }
  } catch (error) {
    yield effects.put({
      type: types.GET_SWITCH_PRODUCTS_ERROR,
      error: (error === null || error === void 0 ? void 0 : error.message) || 'GET_SWITCH_PRODUCTS_ERROR'
    });
  }
}

function* getSwitchProration(_ref) {
  var types = _ref.types,
      productOptionId = _ref.payload;

  try {
    var _yield$call = yield effects.call(networkMiddleware.picoAPIHelper, {
      url: "".concat(endpoints.PURCHASE_SWITCH(), "/").concat(productOptionId),
      method: 'get'
    }),
        data = _yield$call.data;

    if (data) {
      yield effects.put({
        type: types.GET_SWITCH_PRORATION_SUCCESS,
        payload: data
      });
    } else {
      throw new Error('unable to get switch proration data');
    }
  } catch (error) {
    yield effects.put({
      type: types.GET_SWITCH_PRORATION_ERROR,
      error: (error === null || error === void 0 ? void 0 : error.message) || 'GET_SWITCH_PRORATION_ERROR'
    });
  }
}

var getSwitchProductSagas = function getSwitchProductSagas(duck) {
  return {
    createSwitchProduct: function* createSwitchProduct$1(payload) {
      yield createSwitchProduct(Object.assign({}, payload, duck));
    },
    getSwitchProducts: function* getSwitchProducts$1(payload) {
      yield getSwitchProducts(Object.assign({}, payload, duck));
    },
    getSwitchProration: function* getSwitchProration$1(payload) {
      yield getSwitchProration(Object.assign({}, payload, duck));
    }
  };
};

function* getPurchaseHistory(_ref) {
  var types = _ref.types;

  try {
    var _yield$call = yield effects.call(networkMiddleware.picoAPIHelper, {
      url: endpoints.PURCHASE_HISTORY(),
      method: 'get'
    }),
        data = _yield$call.data;

    if (data) {
      yield effects.put({
        type: types.GET_PURCHASE_HISTORY_SUCCESS,
        payload: data
      });
    } else {
      throw new Error('unable to fetch purchase history');
    }
  } catch (error) {
    yield effects.put({
      type: types.GET_PURCHASE_HISTORY_ERROR,
      error: (error === null || error === void 0 ? void 0 : error.message) || 'GET_PURCHASE_HISTORY_ERROR'
    });
  }
}

var sagas = function sagas(duck) {
  return Object.assign({}, getGiftSagas(duck), getSwitchProductSagas(duck), getProductSagas(duck), {
    getPurchaseHistory: function* getPurchaseHistory$1(payload) {
      yield getPurchaseHistory(Object.assign({}, payload, duck));
    }
  });
};

var takes = function takes(_ref) {
  var types = _ref.types,
      sagas = _ref.sagas;
  return [effects.takeEvery(types.GET_PURCHASE_HISTORY, sagas.getPurchaseHistory), effects.takeEvery(types.GET_SWITCH_PRODUCTS, sagas.getSwitchProducts), effects.takeEvery(types.CREATE_SWITCH_PRODUCT, sagas.createSwitchProduct), effects.takeEvery(types.GET_SWITCH_PRORATION, sagas.getSwitchProration), effects.takeEvery(types.GET_GIFT, sagas.getGift), effects.takeEvery(types.CREATE_GIFT, sagas.createGift), effects.takeEvery(types.UPDATE_GIFT, sagas.updateGift), effects.takeEvery(types.DELETE_GIFT, sagas.deleteGift), effects.takeEvery(types.PURCHASE_PRODUCT, sagas.purchaseProduct), effects.takeEvery(types.REACTIVATE_PRODUCT, sagas.reactivateProduct), effects.takeEvery(types.CANCEL_PRODUCT, sagas.cancelProduct)];
};

var selectors = function selectors() {
  return {
    purchase: new Duck__default['default'].Selector(function () {
      return function (state) {
        return state === null || state === void 0 ? void 0 : state.purchase;
      };
    }),
    getPurchases: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.purchase, function () {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            purchases = _ref.purchases;

        return purchases;
      });
    }),
    getProduct: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.purchase, function () {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            product = _ref2.product;

        return product;
      });
    }),
    getSwitchProducts: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.purchase, function () {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            switchProducts = _ref3.switchProducts;

        return switchProducts;
      });
    }),
    getSwitchableProducts: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getSwitchProducts, function () {
        var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [],
            data = _ref4.data;

        return data;
      });
    }),
    getSwitchProductsLoading: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getSwitchProducts, function () {
        var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            loading = _ref5.loading;

        return loading;
      });
    }),
    getSwitchProration: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.purchase, function () {
        var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            switchProration = _ref6.switchProration;

        return switchProration;
      });
    }),
    getGift: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.purchase, function () {
        var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            gift = _ref7.gift;

        return gift;
      });
    }),
    userHasCurrentPurchases: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref8.data;

        return !!Object.keys((data === null || data === void 0 ? void 0 : data.current) || {}).length;
      });
    }),
    nextSubscriptionStart: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$history, _data$history$next;

        var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref9.data;

        return data === null || data === void 0 ? void 0 : (_data$history = data.history) === null || _data$history === void 0 ? void 0 : (_data$history$next = _data$history.next) === null || _data$history$next === void 0 ? void 0 : _data$history$next.subscription_start;
      });
    }),
    nextSubscriptionEnd: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$history2, _data$history2$next;

        var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref10.data;

        return data === null || data === void 0 ? void 0 : (_data$history2 = data.history) === null || _data$history2 === void 0 ? void 0 : (_data$history2$next = _data$history2.next) === null || _data$history2$next === void 0 ? void 0 : _data$history2$next.subscription_end;
      });
    }),
    nextStatusNext: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$history3, _data$history3$next;

        var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref11.data;

        return (data === null || data === void 0 ? void 0 : (_data$history3 = data.history) === null || _data$history3 === void 0 ? void 0 : (_data$history3$next = _data$history3.next) === null || _data$history3$next === void 0 ? void 0 : _data$history3$next.status) === 'NEXT';
      });
    }),
    nextProductOptionPrice: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$history4, _data$history4$next;

        var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref12.data;

        return data === null || data === void 0 ? void 0 : (_data$history4 = data.history) === null || _data$history4 === void 0 ? void 0 : (_data$history4$next = _data$history4.next) === null || _data$history4$next === void 0 ? void 0 : _data$history4$next.product_option_price;
      });
    }),
    nextProductOptionInterval: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$history5, _data$history5$next;

        var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref13.data;

        return data === null || data === void 0 ? void 0 : (_data$history5 = data.history) === null || _data$history5 === void 0 ? void 0 : (_data$history5$next = _data$history5.next) === null || _data$history5$next === void 0 ? void 0 : _data$history5$next.product_option_interval;
      });
    }),
    firstDonation: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$history6;

        var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref14.data;

        return data === null || data === void 0 ? void 0 : (_data$history6 = data.history) === null || _data$history6 === void 0 ? void 0 : _data$history6.first_donation;
      });
    }),
    currentBillingIntervalTotalPaid: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$history7;

        var _ref15 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref15.data;

        return data === null || data === void 0 ? void 0 : (_data$history7 = data.history) === null || _data$history7 === void 0 ? void 0 : _data$history7.current_billing_interval_total_paid;
      });
    }),
    originalEnrollmentDate: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$history8;

        var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref16.data;

        return data === null || data === void 0 ? void 0 : (_data$history8 = data.history) === null || _data$history8 === void 0 ? void 0 : _data$history8.originalEnrollmentDate;
      });
    }),
    next: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$history9;

        var _ref17 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref17.data;

        return Object.keys((data === null || data === void 0 ? void 0 : (_data$history9 = data.history) === null || _data$history9 === void 0 ? void 0 : _data$history9.next) || {}).length ? history.next : null;
      });
    }),
    currentSubscriptionPrice: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$current;

        var _ref18 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref18.data;

        return data === null || data === void 0 ? void 0 : (_data$current = data.current) === null || _data$current === void 0 ? void 0 : _data$current.subscription_price;
      });
    }),
    currentSubscriptionCurrency: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$current2;

        var _ref19 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref19.data;

        return data === null || data === void 0 ? void 0 : (_data$current2 = data.current) === null || _data$current2 === void 0 ? void 0 : _data$current2.subscription_currency;
      });
    }),
    currentSubscriptionType: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$current3;

        var _ref20 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref20.data;

        return data === null || data === void 0 ? void 0 : (_data$current3 = data.current) === null || _data$current3 === void 0 ? void 0 : _data$current3.subscription_type;
      });
    }),
    currentSubscriptionTypeIsPass: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$current4;

        var _ref21 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref21.data;

        return (data === null || data === void 0 ? void 0 : (_data$current4 = data.current) === null || _data$current4 === void 0 ? void 0 : _data$current4.subscription_type) === 'pass';
      });
    }),
    currentSubscriptionTypeIsRecurringDonation: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$current5;

        var _ref22 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref22.data;

        return (data === null || data === void 0 ? void 0 : (_data$current5 = data.current) === null || _data$current5 === void 0 ? void 0 : _data$current5.subscription_type) === 'recurring-donation';
      });
    }),
    currentSubscriptionTypeIsSubscription: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$current6;

        var _ref23 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref23.data;

        return (data === null || data === void 0 ? void 0 : (_data$current6 = data.current) === null || _data$current6 === void 0 ? void 0 : _data$current6.subscription_type) === 'subscription';
      });
    }),
    currentSubscriptionIsTrial: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$current7;

        var _ref24 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref24.data;

        return !!(data !== null && data !== void 0 && (_data$current7 = data.current) !== null && _data$current7 !== void 0 && _data$current7.subscription_trial_end);
      });
    }),
    currentSubscriptionStart: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$current8;

        var _ref25 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref25.data;

        return data === null || data === void 0 ? void 0 : (_data$current8 = data.current) === null || _data$current8 === void 0 ? void 0 : _data$current8.subscription_start;
      });
    }),
    currentProductOptionId: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$current9;

        var _ref26 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref26.data;

        return data === null || data === void 0 ? void 0 : (_data$current9 = data.current) === null || _data$current9 === void 0 ? void 0 : _data$current9.product_option_id;
      });
    }),
    currentProductId: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$current10;

        var _ref27 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref27.data;

        return data === null || data === void 0 ? void 0 : (_data$current10 = data.current) === null || _data$current10 === void 0 ? void 0 : _data$current10.product_id;
      });
    }),
    currentProductOptionCurrency: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$current11;

        var _ref28 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref28.data;

        return data === null || data === void 0 ? void 0 : (_data$current11 = data.current) === null || _data$current11 === void 0 ? void 0 : _data$current11.product_option_currency;
      });
    }),
    currentSubscriptionId: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$current12;

        var _ref29 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref29.data;

        return data === null || data === void 0 ? void 0 : (_data$current12 = data.current) === null || _data$current12 === void 0 ? void 0 : _data$current12.subscription_id;
      });
    }),
    currentSubscriptionIdIsGift: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$current13;

        var _ref30 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref30.data;

        return (data === null || data === void 0 ? void 0 : (_data$current13 = data.current) === null || _data$current13 === void 0 ? void 0 : _data$current13.subscription_id) === 'GIFT';
      });
    }),
    currentSubscriptionEnd: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$current14;

        var _ref31 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref31.data;

        return data === null || data === void 0 ? void 0 : (_data$current14 = data.current) === null || _data$current14 === void 0 ? void 0 : _data$current14.subscription_end;
      });
    }),
    currentSubscriptionPlanTierTitle: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$current15;

        var _ref32 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref32.data;

        return data === null || data === void 0 ? void 0 : (_data$current15 = data.current) === null || _data$current15 === void 0 ? void 0 : _data$current15.plan_tier_title;
      });
    }),
    currentPurchaseCanceled: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$current16;

        var _ref33 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref33.data;

        return (data === null || data === void 0 ? void 0 : (_data$current16 = data.current) === null || _data$current16 === void 0 ? void 0 : _data$current16.status) === 'CANCELED';
      });
    }),
    currentPurchaseActive: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$current17;

        var _ref34 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref34.data;

        return (data === null || data === void 0 ? void 0 : (_data$current17 = data.current) === null || _data$current17 === void 0 ? void 0 : _data$current17.status) === 'ACTIVE';
      });
    }),
    currentPurchaseFailed: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$current18;

        var _ref35 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref35.data;

        return (data === null || data === void 0 ? void 0 : (_data$current18 = data.current) === null || _data$current18 === void 0 ? void 0 : _data$current18.status) === 'FAILED';
      });
    }),
    // group
    isGroupAdmin: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$current19, _data$current19$group;

        var _ref36 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref36.data;

        return !!(data !== null && data !== void 0 && (_data$current19 = data.current) !== null && _data$current19 !== void 0 && (_data$current19$group = _data$current19.group) !== null && _data$current19$group !== void 0 && _data$current19$group.admin);
      });
    }),
    isGroupMember: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$current20, _data$current20$group;

        var _ref37 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref37.data;

        return !!(data !== null && data !== void 0 && (_data$current20 = data.current) !== null && _data$current20 !== void 0 && (_data$current20$group = _data$current20.group) !== null && _data$current20$group !== void 0 && _data$current20$group.member);
      });
    }),
    groupName: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$current21, _data$current21$group;

        var _ref38 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref38.data;

        return data === null || data === void 0 ? void 0 : (_data$current21 = data.current) === null || _data$current21 === void 0 ? void 0 : (_data$current21$group = _data$current21.group) === null || _data$current21$group === void 0 ? void 0 : _data$current21$group.name;
      });
    }),
    groupSize: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$current22, _data$current22$group;

        var _ref39 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref39.data;

        return data === null || data === void 0 ? void 0 : (_data$current22 = data.current) === null || _data$current22 === void 0 ? void 0 : (_data$current22$group = _data$current22.group) === null || _data$current22$group === void 0 ? void 0 : _data$current22$group.size;
      });
    }),
    userHasGroupData: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPurchases, function () {
        var _data$current23;

        var _ref40 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref40.data;

        return !!Object.keys((data === null || data === void 0 ? void 0 : (_data$current23 = data.current) === null || _data$current23 === void 0 ? void 0 : _data$current23.group) || {}).length;
      });
    })
  };
};

var store = 'purchase';
var index = (function (_ref) {
  var createDuck = _ref.createDuck;
  return createDuck({
    store: store,
    initialState: initialState
  }).extend({
    creators: creators,
    types: types,
    reducer: reducer,
    sagas: sagas,
    takes: takes,
    selectors: selectors
  });
});

exports.creators = creators;
exports.default = index;
exports.initialState = initialState;
exports.reducer = reducer;
exports.sagas = sagas;
exports.store = store;
exports.takes = takes;
exports.types = types;
